// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { type KLSpecificRule } from '../reducers/kl';
import { RoundIdByCollectibleId, type KLRound } from '../types/round';

import { getBadgeIdFromProps, getStepIdFromProps } from './user';

const emptyObj = {};

export const getRoundIdFromProps = (_: StateType, { roundId }: { roundId: KLRound }) => roundId;

const selectRoundId = createSelector(
  [getRoundIdFromProps, getBadgeIdFromProps, getStepIdFromProps],
  (roundId, badgeId, stepId) => roundId ?? RoundIdByCollectibleId[badgeId ?? stepId],
);

export const selectKLRulesState = createSelector([(state: StateType) => state.kl], (kl) => kl.rules ?? emptyObj);

export const selectSpecificKLRule = createSelector(
  [selectKLRulesState, selectRoundId],
  (rulesState, roundId): KLSpecificRule => rulesState.specifics[roundId] ?? emptyObj,
);

export const selectKLRuleStakeMultiplicator = createSelector(
  selectSpecificKLRule,
  (specific) => specific.stakeMultiplicator,
);

export const selectKLRuleH1StakeMultiplicator = createSelector(
  selectSpecificKLRule,
  (specific) => specific.h1StakeMultiplicator,
);

export const selectKLRuleH2StakeMultiplicator = createSelector(
  selectSpecificKLRule,
  (specific) => specific.h2StakeMultiplicator,
);

export const selectKLRuleH4StakeMultiplicator = createSelector(
  selectSpecificKLRule,
  (specific) => specific.h4StakeMultiplicator,
);

export const selectKLRuleH6StakeMultiplicator = createSelector(
  selectSpecificKLRule,
  (specific) => specific.h1StakeMultiplicator,
);

export const selectKLRuleMinOdds = createSelector([selectSpecificKLRule], (specific) => specific.minOdds ?? emptyObj);

export const selectKLBadgeMinOddsRuleByBadgeId = createSelector(
  [selectKLRuleMinOdds, getBadgeIdFromProps],
  (minOdds, badgeId) => minOdds[badgeId],
);

export const selectKLOrientationStepMinOddsRuleByOrientationStepId = createSelector(
  [selectKLRuleMinOdds, getStepIdFromProps],
  (minOdds, stepId) => minOdds[stepId],
);
